export default __webpack_public_path__ + "static/media/Suiting.faa4f867.png";